import { render, staticRenderFns } from "./ExpansionUpdateForm.vue?vue&type=template&id=c2cee0d0"
import script from "./ExpansionUpdateForm.vue?vue&type=script&lang=js"
export * from "./ExpansionUpdateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports